export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  hub: () => import("/opt/build/repo/layouts/hub.vue").then(m => m.default || m),
  "hub-blank": () => import("/opt/build/repo/layouts/hubBlank.vue").then(m => m.default || m),
  "no-auth": () => import("/opt/build/repo/layouts/noAuth.vue").then(m => m.default || m),
  onboarding: () => import("/opt/build/repo/layouts/onboarding.vue").then(m => m.default || m)
}